import { Faq } from "@appComponents/Faq";
import { Tabs } from "antd";
import React from "react";
import {
  overviewText,
  faq,
  shareOwnershipFaq,
  howInvestmentWorkFaq,
  securityAndRegulationFaq,
  feesReturnsAndLiquidityFaq,
  shareOwnershipText,
  gettingStartedText,
  howToInvestmentsWorkText,
  securityAndRegulationText,
  feesReturnsAndLiquidityText,
} from "../utils/const";

const tabs = [
  {
    label: "Overview",
    key: "overview",
    children: <>{overviewText}</>,
  },
  {
    label: "Getting Started",
    key: "faq",
    children: (
      <>
        {gettingStartedText}
        <Faq faq={faq} />
      </>
    ),
  },
  {
    label: "How Investments Work",
    key: "howInvestmentWork",
    children: (
      <>
        {howToInvestmentsWorkText}
        <Faq faq={howInvestmentWorkFaq} />
      </>
    ),
  },
  {
    label: "Security & Regulation",
    key: "securityAndRegulation",
    children: (
      <>
        {securityAndRegulationText}
        <Faq faq={securityAndRegulationFaq} />
      </>
    ),
  },
  {
    label: "Fees, Returns & Liquidity",
    key: "feesReturnsAndLiquidity",
    children: (
      <>
        {feesReturnsAndLiquidityText}
        <Faq faq={feesReturnsAndLiquidityFaq} />
      </>
    ),
  },
  {
    label: "Share ownership",
    key: "shareOwnership",
    children: (
      <>
        <p>{shareOwnershipText}</p>
        <Faq faq={shareOwnershipFaq} />
      </>
    ),
  },
];

export const FaqSection = () => {
  return (
    <Tabs defaultActiveKey={tabs[0].key} items={tabs} destroyInactiveTabPane />
  );
};
